<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 700px; height: 800px;" data-cy="note-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="note-dialog-header-section">
      <div class="section-header-title" data-cy="note-dialog-title-text">
        Note @if (data.isLocked) {
        <span style="color: var(--tdo-secondary-accent); font-size: 0.9em;">(Locked)</span>
      }
    </div>
    <div style="flex: 1;"></div>
  </div>
  <!--  MAIN AREA-->
  <div class="section-content" style="flex: 1; overflow-y: hidden;" data-cy="note-dialog-content-section">
    <textarea
      style="outline: unset; border: 1px solid var(--tdo-primary-accent); resize: none; height: 100%; width: 100%; overflow-y: auto;"
      rows="40"
      [(ngModel)]="data.note.Note"
      [disabled]="data.isLocked"
      [style.background-color]="data.isLocked ? 'var(--tdo-disabled-background, #f5f5f5)' : 'white'"
      [style.color]="data.isLocked ? 'var(--tdo-disabled-color, #999)' : 'inherit'"
    data-cy="note-dialog-textarea"></textarea>
  </div>
  <!--  FOOTER-->
  <div class="section-footer" style="flex-basis: 46px; min-height: 46px; padding-top: 6px;" data-cy="note-dialog-footer-section">
    <div style="flex: 1; margin-right: 6px;"></div>
    <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="note-dialog-ok-button">Ok</button>
  </div>
</div>
</div>
